import React, { FC } from 'react'

interface PlusCircleIconProps {
  size?: number
  color?: string
  opacity?: number
}

/**
 * 圆形加号图标组件 - 来自tipsy-app
 * 包含圆形背景和十字图标的完整组合
 */
export const PlusCircleIcon: FC<PlusCircleIconProps> = ({
  size = 14,
  color = 'white',
  opacity = 0.8,
}) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM7 2.5C7.55228 2.5 8 2.94772 8 3.5V6H10.5C11.0523 6 11.5 6.44772 11.5 7C11.5 7.55228 11.0523 8 10.5 8H8V10.5C8 11.0523 7.55228 11.5 7 11.5C6.44772 11.5 6 11.0523 6 10.5V8H3.5C2.94772 8 2.5 7.55228 2.5 7C2.5 6.44772 2.94772 6 3.5 6H6V3.5C6 2.94772 6.44772 2.5 7 2.5Z"
      fill={color}
      fillOpacity={opacity}
    />
  </svg>
)

export default PlusCircleIcon
